import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts';
import useWindowDimensions from '../../../../utils/useWindowDimensions';

const CourseDistriBution = ({ language }) => {
    let { width, height } = useWindowDimensions();
    const [allLanguage, setAllLanguage] = useState([]);
    const defaultColors = ["#3e4095", "#333333", "#5972FF", "#31BACC", "#7E57C2", "#26A69A"];

    const [chartData, setChartData] = useState({
        series: [],
        options: {
            chart: {
                type: 'donut',
                stroke: {
                    show: false,
                },
            },
            legend: {
                position: 'bottom',
                show: false
            },
            plotOptions: {
                pie: {
                    donut: {
                        width: '70%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '17px',
                                lineHeight: '1'
                            },
                            value: {
                                show: true,
                                fontSize: '14px',
                                lineHeight: '1',
                            },
                            total: {
                                show: true,
                                label: 'Total ',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                color: '#333',
                            },
                        },
                    },
                },
            },
            stroke: {
                width: 0,
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200,
                        },
                        legend: {
                            position: 'bottom',
                        },
                    },
                },
            ],
            colors: [],
            labels: [],
        },
    });

    useEffect(() => {

        if (language.length > 0) {
            let valid = language.filter((e) => e.key != "NA");
            let label = valid.map(e => e.key);
            let count = valid.map(e => e.count);
            let color = valid.map((e, index) => e.color && e.color !== "#CA353B"
                ? e.color
                : defaultColors[index % defaultColors.length]);

            // Step 1: Calculate the total count
            let totalCount = count.reduce((sum, count) => sum + count, 0);
            let proportions = count.map(count => (count / totalCount) * 100);
            proportions = proportions.map(proportion => Math.round(proportion * 10) / 10);
            let roundingDifference = 100 - Math.round(proportions.reduce((sum, val) => sum + val, 0));
            proportions[proportions.length - 1] += roundingDifference;
            let resultArray = label.map((language, index) => ({
                language: language,
                color: color[index],
                percentage: proportions[index]
            }));
            setAllLanguage(resultArray);

            setChartData({
                series: count,
                options: {
                    chart: {
                        type: 'donut',
                        stroke: {
                            show: false,
                        },
                    },
                    legend: {
                        position: 'bottom',
                        show: false
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                width: '70%',
                                labels: {
                                    show: true,
                                    name: {
                                        show: true,
                                        fontSize: '17px',
                                        lineHeight: '1'
                                    },
                                    value: {
                                        show: true,
                                        fontSize: '14px',
                                        lineHeight: '1',
                                    },
                                    total: {
                                        show: true,
                                        label: 'Total ',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                        color: '#333',
                                    },
                                },
                            },
                        },
                    },
                    stroke: {
                        width: 0,
                    },
                    responsive: [
                        {
                            breakpoint: 480,
                            options: {
                                chart: {
                                    width: 200,
                                },
                                legend: {
                                    position: 'bottom',
                                },
                            },
                        },
                    ],
                    colors: color,
                    labels: label,
                },
            });

        }
    }, [language])

    return (
        <>
            <div id="chart" className='langchart' style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly", gap: "20px" }}>
                <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="donut"
                    height={width > 1500 ? 250 : 200}
                    width={width > 1500 ? 250 : 200}
                />
                <div className='chartlegends' style={{ flexDirection: "column", alignItems: "start", gap: "10px" }}>
                    
                    {allLanguage.map((e, index) => {
                        return (
                            <p className='language' key={index}> <span style={{ backgroundColor: e.color }} >{""}</span> {e.language} : {e.percentage}% </p>
                        )
                    })}

                </div>
            </div>
        </>
    )
}

export default CourseDistriBution
